const About = () => {
  return (
    <section id="about" className="section-padding bg-white">
      <div className="container-custom">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            VỀ <span className="text-gradient">UPOWER GROUP</span>
          </h2>
          <p className="text-xl text-primary font-semibold mb-4">
            NƠI KIẾN TẠO THÀNH CÔNG
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="space-y-6">
            <div className="bg-primary-50 rounded-2xl p-6 md:p-8">
              <h3 className="text-2xl font-bold text-primary mb-4">
                Lịch sử hình thành
              </h3>
              <p className="text-gray-700 leading-relaxed">
                Upower Group được thành lập vào ngày{' '}
                <span className="font-semibold text-primary">13/06/2013</span>,
                hoạt động chuyên sâu trong lĩnh vực đào tạo Tư duy, Phát triển
                bản thân, Bán hàng, Marketing, Lãnh đạo, Coaching...
              </p>
            </div>

            <div className="bg-white rounded-2xl p-6 md:p-8 shadow-lg border border-primary/10">
              <h3 className="text-2xl font-bold text-primary mb-4">
                Thành tựu đạt được
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                Với hơn{' '}
                <span className="font-semibold text-primary">
                  80,000 học viên
                </span>{' '}
                đã tham gia hàng trăm khóa học về Tư duy & Phát triển bản thân
                tại Việt Nam và cộng đồng người Việt tại Mỹ, Upower tự hào hiện
                thực hóa sứ mệnh và tầm nhìn của mình.
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-primary text-white rounded-2xl p-6 text-center">
                <h4 className="text-xl font-bold mb-2">Sứ mệnh</h4>
                <p className="font-medium">
                  &ldquo;Vì Một Cộng Đồng Sống Có Mục Đích&rdquo;
                </p>
              </div>
              <div className="bg-primary-700 text-white rounded-2xl p-6 text-center">
                <h4 className="text-xl font-bold mb-2">Tầm nhìn</h4>
                <p className="font-medium">
                  &ldquo;Trở Thành Tổ Chức Khởi Nghiệp Hàng Đầu Việt Nam&rdquo;
                </p>
              </div>
            </div>
          </div>

          {/* Visual/Stats */}
          <div className="space-y-6">
            <div className="bg-gradient-to-br from-primary to-primary-700 rounded-2xl p-8 text-white text-center">
              <h3 className="text-2xl font-bold mb-6">Những con số ấn tượng</h3>
              <div className="grid grid-cols-2 gap-6">
                <div>
                  <div className="text-3xl font-bold mb-2">80,000+</div>
                  <div className="text-primary-100">Học viên</div>
                </div>
                <div>
                  <div className="text-3xl font-bold mb-2">10+</div>
                  <div className="text-primary-100">Năm kinh nghiệm</div>
                </div>
                <div>
                  <div className="text-3xl font-bold mb-2">100+</div>
                  <div className="text-primary-100">Khóa học</div>
                </div>
                <div>
                  <div className="text-3xl font-bold mb-2">2</div>
                  <div className="text-primary-100">Quốc gia</div>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 rounded-2xl p-6 md:p-8">
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                Cam kết chất lượng
              </h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start">
                  <svg
                    className="w-5 h-5 text-primary mt-1 mr-3 flex-shrink-0"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  Chương trình đào tạo thực chiến
                </li>
                <li className="flex items-start">
                  <svg
                    className="w-5 h-5 text-primary mt-1 mr-3 flex-shrink-0"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  Đội ngũ chuyên gia hàng đầu
                </li>
                <li className="flex items-start">
                  <svg
                    className="w-5 h-5 text-primary mt-1 mr-3 flex-shrink-0"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  Hỗ trợ học viên trọn đời
                </li>
                <li className="flex items-start">
                  <svg
                    className="w-5 h-5 text-primary mt-1 mr-3 flex-shrink-0"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  Cộng đồng học tập mạnh mẽ
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
